export default __webpack_public_path__ + "static/media/wave-single.657ce0be.svg";